module.exports = __webpack_public_path__ + "img/start4.9f6196b.png";